import { trackEvent, TrackingType } from 'tracking/events'

// Page level events/actions

export enum RegAction {
  VALIDATION_ERROR = 'validation_error',
  BLUR_EVENT = 'Focus OUT',
}

const getSchema = () => 'reg_page_tracking'

interface EventData {
  fieldName?: string
  fieldValue?: string
}

interface RegActionOptions {
  action: RegAction
  trackingType?: TrackingType
  eventData?: Record<keyof EventData, any>
}

export const trackSignupAction = ({
  trackingType = TrackingType.BATCHED,
  action,
  eventData,
}: RegActionOptions) =>
  trackEvent({
    type: trackingType,
    schema: getSchema(),
    payload: {
      event_name: action,
      form_name: 'direct_homepage_signup_modal',
      field_name: eventData.fieldName,
      field_value: eventData.fieldValue,
    },
  })

// Validation errors

export const trackValidationErrors = (eventData: EventData) =>
  trackSignupAction({
    action: RegAction.VALIDATION_ERROR,
    eventData: {
      fieldValue: eventData.fieldValue,
      fieldName: 'email',
    },
  })

//Track Field OnBlur event

export const trackOnBlur = (eventData: EventData) =>
  trackSignupAction({
    action: RegAction.BLUR_EVENT,
    eventData: {
      fieldValue: eventData.fieldValue,
      fieldName: eventData.fieldName,
    },
  })
